import React, { useEffect, useState } from "react";
import { Link, matchPath, Navigate, NavLink, Outlet, useLocation, useMatch, useNavigate } from "react-router-dom";
import Images from "../../../assets/images/index";
import Header from "../header/Header";
// import { Link, NavLink } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import { useMutation, useQuery } from "@apollo/client";
import { Result_Submit } from "../../../gql/mutation";
import { GET_Instrucation_QB, Get_server_time, GET_Sidebar_Instrucation_QB, Get_test } from "../../../gql/queries";
import moment from "moment";
import { decrypt } from "../../../utils/crypto";
import { profileCheck } from "../../../utils/logout";
import ErrorBoundry from "../Boundary/ErrorBoundary"

function Sidebar() {
    const [qbResume, qbShow] = useState(false);
    const qbHide = () => qbShow(false);
    const [Resume, Show] = useState(false);
    const Hide = () => Show(false);
    const match = useMatch('/testlayer/testattempt/:id');
    const qbmatch = useMatch('/qblayer/qbattempt/:id/:name');

    // const [test,setId] = useState((localStorage.getItem('testId')))
    const navigate = useNavigate()
    const location = useLocation()
    const [isOpen, setIsOpen] = useState(false)
    if ((localStorage.getItem('profileDetails')) == 'undefined' || (localStorage.getItem('profileDetails')) == '' || (localStorage.getItem('profileDetails')) == 'null' || localStorage.getItem('profileDetails') == '{}' || decrypt(localStorage.getItem('profileDetails')) == {} || decrypt(localStorage.getItem('profileDetails')) == undefined || decrypt(localStorage.getItem('profileDetails')) == null || decrypt(localStorage.getItem('profileDetails')) == '') {
        profileCheck(navigate)
    }
    const [course, setCourse] = useState((decrypt(localStorage.getItem('profileDetails')) !== undefined ? JSON.parse(decrypt(localStorage.getItem('profileDetails'))) : ''));

    // const redirectToProfile = () => {
    //     setUpdateModal(false)
    //     setSelectedTab('/account')
    // }

    // useEffect(() => {
    //     const getConfigData = async () => {
    //         try {
    //             const remoteData = await firebaseData('showCollegeLockedPopup'); // Replace 'your_config_key' with the actual key for the configuration value you want
    //             setUpdateModalConfig(JSON.parse(remoteData));
    //             setRemoteLoading(false);
    //         } catch (error) {
    //             console.error('Error fetching remote data:', error);
    //             setRemoteLoading(false);
    //         }
    //     };

    //     if (typeof window !== 'undefined') {
    //         getConfigData();
    //     }
    // }, [])

    // useEffect(() => {      
    //     // showCollegeLockedPopup
    //     let isUpdated = false
    //     if (!course?.collegeName) {
    //         isUpdated = true
    //     } else {
    //         isUpdated = false
    //     }
    //     // address check condition
    //     if (updateModalConfig && isUpdated && location.pathname !== "/account/editProfile") {
    //         setUpdateModal(true)
    //     }
    // }, [location])
    // const onClose = () => {
    //     setIsOpen(false);
    // }
    const parts = location.pathname.split('/'); // Split the URL by '/'
    const keywords = [];

    for (const part of parts) {
        if (part === "qblayer" || part === "testlayer" || part === 'videolayer' || part === 'account' || part === 'package' || part === 'mantras') {
            keywords.push(part);
        }
    }
    // console.log(keywords[0],"kkkkkkkkkkkk")
    let [selectedTab, setSelectedTab] = useState(keywords[0]?.length ? '/' + keywords[0] : null);

    const handleTabClick = (tabName) => {
        setSelectedTab(tabName);
    };

    
    

    const query2 = useQuery(Get_server_time)
    const query1 = useQuery(Get_test, {
        variables: {
            "_id": localStorage.getItem('testId'),
        },
    });
    const query3 = useQuery(GET_Sidebar_Instrucation_QB, {
        variables: {
            "_id": JSON.parse(localStorage.getItem('qbId'))?.id,
        },
        fetchPolicy: 'network-only'
    });
    // console.log(query3.data,"kkkkkkkkkkkkk")
    let localAttemtedQuestions = JSON.parse(localStorage.getItem(localStorage.getItem('testId'))) ? JSON.parse(localStorage.getItem(localStorage.getItem('testId'))) : [];
    let qblocalAttemtedQuestions = JSON.parse(localStorage.getItem(JSON.parse(localStorage.getItem('qbId'))?.id)) ? JSON.parse(localStorage.getItem(JSON.parse(localStorage.getItem('qbId'))?.id)) : [];

    let qbnewquestionAttempt = []
    qblocalAttemtedQuestions && qblocalAttemtedQuestions != undefined && qblocalAttemtedQuestions.map((obj, i) => {
        let data = {
            userAnswer: obj?.userAnswer,
            questionId: obj?.questionId
        }
        qbnewquestionAttempt[i] = data
    })
    // console.log(qbnewquestionAttempt,"qbnewquestionAttempt")
    const [resultSubmit] = useMutation(Result_Submit, {
        refetchQueries: [
            {
                query: GET_Sidebar_Instrucation_QB,
                variables: {
                    "_id": JSON.parse(localStorage.getItem('qbId'))?.id,
                },
            }, // DocumentNode object parsed with gql
            'qbInformation' // Query name,

        ],
    })
    let newquestionAttempt = []
    let data
    localAttemtedQuestions && localAttemtedQuestions != null && localAttemtedQuestions != undefined && localAttemtedQuestions.map((obj1, i) => {
        if (obj1 !== null) {
            data = {
                userAnswer: obj1?.userAnswer,
                questionId: obj1?.questionId,
                isReview: obj1?.isReview,
                isGuessed: obj1?.isGuessed
            }
            newquestionAttempt.push(data)
        }
    })
    const getResumeTestTime = (server, start, duration) => {
        const startdateTime = new Date(start);
        const serverdateTime = new Date(server);
        const timeDifferenceInMilliseconds = (serverdateTime - startdateTime);
        const totalduration = (timeDifferenceInMilliseconds / 1000);
        let resumeTime = parseInt(((duration) - (totalduration / 60)))
        resumeTime = resumeTime * 60
        resumeTime = (parseInt(duration) * 60) - resumeTime
        return resumeTime
    }
    const gotoInstrucation = async () => {
        try {
            // Use await to ensure that query2.refetch() is completed before proceeding
            const response = await query2.refetch();
            //   console.log(response.data?.serverTime, "kkkkkkkkkk");
            if (response && response?.data) {
                const startTime = query1.data?.test?.progress?.startTime;
                const serverTime = response?.data?.serverTime;

                const resumeTestTime = getResumeTestTime(serverTime, startTime, query1.data?.test?.duration);
                const duration = parseFloat(resumeTestTime.toFixed(1));

                const resultInput = {
                    qbId: query1.data?.test?._id,
                    resultType: "Test",
                    startTime: startTime,
                    endTime: serverTime,
                    duration: duration,
                    questions: newquestionAttempt,
                    questionInterval: 0.0,
                    category: query1.data.test.category,
                    isCompleted: false,
                    subjectId: query1.data.test.subject,
                    topicId: query1.data.test.subjectDetail.topicId,
                    courseName: course?.preparingFor,
                };

                // Now, call resultSubmit only after ensuring that query2.data is available
                resultSubmit({ variables: { resultInput } });
                qbHide()
                selectedTab = '/testlayer'
                setSelectedTab('/testlayer')
                navigate(`/testlayer/testinstruction/${localStorage.getItem('testId')}`);
            }
        } catch (error) {
            // Handle any errors that occur during the refetch or resultSubmit process
            console.error("Error:", error);
        }
    };
    // const gotoInstrucation = () => {
    //     query2.refetch()
    //     if(!query2.loading &&query2?.data && query2?.data?.serverTime){
    //     resultSubmit({ variables: { resultInput: { qbId: query1?.data?.test?._id, resultType: "Test", startTime: query1?.data?.test?.progress?.startTime, endTime: query2.data && query2?.data?.serverTime, duration: parseFloat(getResumeTestTime(query2.data && query2?.data?.serverTime,query1?.data?.test?.progress?.startTime,query1?.data?.test?.duration).toFixed(1)), questions: newquestionAttempt, questionInterval: 0.0, category: query1.data?.test?.category, isCompleted: false, subjectId: query1.data?.test?.subject, topicId: query1.data?.test?.subjectDetail?.topicId, courseName: course?.preparingFor } } })
    //     qbHide()
    //     selectedTab='/testlayer'
    //     setSelectedTab('/testlayer')
    //     navigate(`/testlayer/testinstruction/${localStorage.getItem('testId')}`);

    //     }
    // }
    // console.log(query3.data,"kkkkkkkkkkkkkkk")
    const qbgotoInstrucation = () => {
        resultSubmit({ variables: { resultInput: { qbId: query3.data.qb._id, resultType: "Qb", startTime: query3.data?.qb?.progress?.startTime, endTime: new Date(), duration: (moment.duration((moment(new Date())).diff(moment(query3.data?.qb?.progress?.startTime)))).asSeconds(), questions: qbnewquestionAttempt, questionInterval: JSON.parse(localStorage.getItem('qbId')).time, isCompleted: false, subjectId: query3.data.qb.subject, topicId: query3.data.qb.subjectDetail.topicId, courseName: query3.data.qb.course[0] } } })
        Hide()
        selectedTab = '/qblayer'
        setSelectedTab('/qblayer')
        navigate(`/qblayer/qbinstructions/${JSON.parse(localStorage.getItem('qbId'))?.id}/${JSON.parse(localStorage.getItem('qbId')).name}`);
    }

    const navigationHandler = (name) => {
        selectedTab = name
        setSelectedTab(name)
        setIsOpen(false)
        if (qbmatch !== null)
            if (qbmatch) {
                Show(true)
            }
            else {
                navigate(selectedTab)
            }
        else {
            if (match) {
                qbShow(true)
            } else {
                // handleTabClick()
                navigate(selectedTab)
            }
        }
    }

    return (
        <>
            <Header onOpen={() => setIsOpen(true)} />
            <aside className={isOpen ? `sidebar_wrapper sidebar_drawer` : `sidebar_wrapper`}>
                {/* <span className="cross_sidebar" onClick={(e) => onClose()}>
                        <img src={Images.Cross} alt="" className="img-fluid"/>
                    </span> */}
                <div className="sidebar_options">
                    <ul type="none" className="child_options">
                        {/* <li className="nav-item">
                                <NavLink to="/" className="nav-link homepage">
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M2.5 7.5013L10 1.66797L17.5 7.5013V16.668C17.5 17.11 17.3244 17.5339 17.0118 17.8465C16.6993 18.159 16.2754 18.3346 15.8333 18.3346H4.16667C3.72464 18.3346 3.30072 18.159 2.98816 17.8465C2.67559 17.5339 2.5 17.11 2.5 16.668V7.5013Z" stroke="white" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
                                        <path d="M7.5 18.3333V10H12.5V18.3333" stroke="white" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                    <span>Home</span>
                                </NavLink>
                            </li> */}
                        <li>

                            <a className={`nav-link video_link ${selectedTab === '/videolayer' ? 'active' : ''}`} onClick={() => navigationHandler('/videolayer')}>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clipPath="url(#clip0_228_1912)">
                                        <path d="M19.1663 5.83203L13.333 9.9987L19.1663 14.1654V5.83203Z" stroke="white" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M11.6663 4.16797H2.49967C1.5792 4.16797 0.833008 4.91416 0.833008 5.83464V14.168C0.833008 15.0884 1.5792 15.8346 2.49967 15.8346H11.6663C12.5868 15.8346 13.333 15.0884 13.333 14.168V5.83464C13.333 4.91416 12.5868 4.16797 11.6663 4.16797Z" stroke="white" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_228_1912">
                                            <rect width="20" height="20" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
                                <span>Video</span>
                            </a>
                        </li>
                        <li>
                            <a className={`nav-link qbanks_link ${selectedTab === '/qblayer' ? 'active' : ''}`} onClick={() => navigationHandler('/qblayer')}>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clipPath="url(#clip0_228_1923)">
                                        <path d="M10.0003 18.3346C14.6027 18.3346 18.3337 14.6037 18.3337 10.0013C18.3337 5.39893 14.6027 1.66797 10.0003 1.66797C5.39795 1.66797 1.66699 5.39893 1.66699 10.0013C1.66699 14.6037 5.39795 18.3346 10.0003 18.3346Z" stroke="white" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M7.5752 7.49852C7.77112 6.94158 8.15782 6.47194 8.66682 6.1728C9.17583 5.87365 9.77427 5.7643 10.3562 5.86411C10.9381 5.96393 11.4659 6.26646 11.8461 6.71813C12.2263 7.1698 12.4344 7.74146 12.4335 8.33185C12.4335 9.99852 9.93353 10.8319 9.93353 10.8319" stroke="white" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M10 14.168H10.0083" stroke="white" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_228_1923">
                                            <rect width="20" height="20" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
                                <span>QBank</span>
                            </a>
                        </li>
                        <li>
                            <a className={`nav-link test_link ${selectedTab === '/testlayer' ? 'active' : ''}`} onClick={() => navigationHandler("/testlayer")}>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M11.6663 1.66797H4.99967C4.55765 1.66797 4.13372 1.84356 3.82116 2.15612C3.5086 2.46868 3.33301 2.89261 3.33301 3.33464V16.668C3.33301 17.11 3.5086 17.5339 3.82116 17.8465C4.13372 18.159 4.55765 18.3346 4.99967 18.3346H14.9997C15.4417 18.3346 15.8656 18.159 16.1782 17.8465C16.4907 17.5339 16.6663 17.11 16.6663 16.668V6.66797L11.6663 1.66797Z" stroke="white" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M11.667 1.66797V6.66797H16.667" stroke="white" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M13.3337 10.832H6.66699" stroke="white" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M13.3337 14.168H6.66699" stroke="white" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M8.33341 7.5H7.50008H6.66675" stroke="white" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                <span>Test</span>
                            </a>
                        </li>
                        <li>
                            <a className={`nav-link account_link ${selectedTab === '/account' ? 'active' : ''}`} onClick={() => navigationHandler('/account')}>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M16.6666 17.5V15.8333C16.6666 14.9493 16.3154 14.1014 15.6903 13.4763C15.0652 12.8512 14.2173 12.5 13.3333 12.5H6.66659C5.78253 12.5 4.93468 12.8512 4.30956 13.4763C3.68444 14.1014 3.33325 14.9493 3.33325 15.8333V17.5" stroke="white" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M10.0001 9.16667C11.841 9.16667 13.3334 7.67428 13.3334 5.83333C13.3334 3.99238 11.841 2.5 10.0001 2.5C8.15913 2.5 6.66675 3.99238 6.66675 5.83333C6.66675 7.67428 8.15913 9.16667 10.0001 9.16667Z" stroke="white" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                <span>Account</span>
                            </a>
                        </li>
                        <li>
                            <a className={`nav-link account_link ${selectedTab === '/package' ? 'active' : ''}`} onClick={() => navigationHandler('/package')}>
                                <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3.88283 1.00241C3.82542 1.02035 3.74649 1.05623 3.71062 1.08493C3.67474 1.11004 3.0146 2.24736 2.23964 3.60352L0.833252 6.07547L0.83684 6.36249C0.847603 6.86119 1.03417 7.39217 1.34989 7.81194C1.53286 8.0559 1.92392 8.39315 2.18942 8.53666L2.39392 8.64429V12.6482C2.39392 17.0611 2.37957 16.8028 2.61994 16.9463C2.73116 17.0181 2.85315 17.0181 9.99992 17.0181C17.1467 17.0181 17.2687 17.0181 17.3799 16.9463C17.6203 16.8028 17.6059 17.0611 17.6059 12.6482V8.64429L17.8176 8.53307C18.5997 8.11689 19.1486 7.22713 19.163 6.36249L19.1666 6.07547L17.7889 3.65375C17.0319 2.3227 16.3682 1.18539 16.3143 1.13157C16.2605 1.07417 16.1565 1.01676 16.0775 0.998823C15.891 0.952183 4.02634 0.959358 3.88283 1.00241ZM16.8059 3.76138L17.8571 5.60907L13.9285 5.61983C11.7687 5.62342 8.23116 5.62342 6.07135 5.61983L2.14278 5.60907L3.19398 3.75421L4.2416 1.89935L9.99992 1.90652L15.7582 1.9137L16.8059 3.76138ZM5.13495 6.62081C4.86946 7.72583 3.66398 8.27834 2.64506 7.76171C2.43697 7.65766 2.17148 7.42087 2.03156 7.21996C1.93469 7.07645 1.74812 6.64592 1.74812 6.55982C1.74812 6.53829 2.36522 6.52394 3.4523 6.52394H5.15647L5.13495 6.62081ZM9.48328 6.67462C9.44741 6.90065 9.25367 7.23431 9.02764 7.46034C8.34597 8.14201 7.22301 8.11689 6.56645 7.40652C6.36554 7.19126 6.18257 6.86477 6.13951 6.63875L6.11799 6.52394H7.8114H9.5084L9.48328 6.67462ZM13.8603 6.63875C13.7491 7.19484 13.1966 7.75094 12.6046 7.9088C11.966 8.08102 11.1982 7.80835 10.8072 7.27736C10.6601 7.07645 10.5058 6.73203 10.5022 6.60287V6.52394H12.192H13.8854L13.8603 6.63875ZM18.2302 6.65668C18.18 6.89347 17.979 7.23072 17.7674 7.4424C17.179 8.03438 16.3072 8.12766 15.6111 7.67919C15.256 7.44957 15.0227 7.13385 14.8936 6.7105L14.847 6.55982H16.5511H18.2517L18.2302 6.65668ZM6.00677 8.12766C6.28302 8.40032 6.62027 8.60483 7.00416 8.73398C7.41316 8.87391 7.99796 8.89543 8.4249 8.7878C8.93077 8.66223 9.28237 8.46132 9.66985 8.07743L10.0035 7.74736L10.3156 8.05949C10.6672 8.41109 10.9614 8.59765 11.3812 8.73757C11.6395 8.82726 11.722 8.83444 12.1884 8.83444C12.6656 8.83803 12.7302 8.82726 12.9957 8.73757C13.1535 8.68017 13.3903 8.57254 13.5231 8.4936C13.7635 8.35368 14.1581 7.9985 14.2909 7.80476L14.3626 7.7043L14.5384 7.92315C14.9833 8.47567 15.7618 8.85238 16.4686 8.85597H16.709V12.4796V16.1032H12.9957H9.28237V13.6312C9.28237 12.1244 9.26802 11.0875 9.24649 10.9727C9.13527 10.3843 8.70116 9.92511 8.11636 9.77084C7.82575 9.6955 6.38707 9.6955 6.07135 9.76725C5.55471 9.88923 5.13495 10.2803 4.95197 10.8149C4.89816 10.9727 4.89098 11.2597 4.88022 13.5451L4.86587 16.1032H4.07657H3.29085V12.4796V8.85597H3.53482C4.23801 8.85238 5.01655 8.47567 5.46143 7.92315L5.63723 7.7043L5.70899 7.80476C5.74486 7.85858 5.8812 8.00567 6.00677 8.12766ZM8.00873 10.6821C8.18094 10.7611 8.25628 10.84 8.33162 11.0194C8.37826 11.1306 8.38544 11.4786 8.38544 13.6277V16.1032H7.09385H5.80227V13.6133C5.80227 11.9342 5.81303 11.0875 5.84173 11.0194C5.89555 10.8759 6.01394 10.7575 6.17898 10.6821C6.30455 10.6247 6.41936 10.614 7.09385 10.614C7.76476 10.614 7.88315 10.6247 8.00873 10.6821Z" fill="#fff" />
                                    <path d="M11.0511 9.75654C10.8573 9.80318 10.5416 10.0149 10.3981 10.1942C10.3371 10.2732 10.2546 10.4239 10.2151 10.5315C10.1434 10.7216 10.1398 10.7898 10.1505 11.9558L10.1613 13.1792L10.2546 13.3802C10.3766 13.6385 10.599 13.8609 10.8573 13.9829L11.0582 14.0762H12.6189H14.1796L14.3805 13.9829C14.6388 13.8609 14.8612 13.6385 14.9832 13.3802L15.0765 13.1792V11.9056V10.6319L14.9832 10.4346C14.8648 10.1871 14.6352 9.95745 14.3769 9.83188L14.1796 9.73501L12.6907 9.72784C11.8296 9.72425 11.1372 9.7386 11.0511 9.75654ZM14.0181 10.6678C14.0755 10.6965 14.1401 10.7539 14.1616 10.7898C14.1832 10.8329 14.1975 11.2634 14.1975 11.9235V12.9891L14.0935 13.0931L13.9894 13.1972H12.6189H11.2484L11.1443 13.0931L11.0403 12.9891V11.9164C11.0403 10.7647 11.0475 10.7252 11.234 10.6499C11.2735 10.6319 11.8942 10.6176 12.6117 10.6176C13.706 10.614 13.932 10.6212 14.0181 10.6678Z" fill="#fff" />
                                </svg>
                                <span>Subscriptions</span>
                            </a>
                        </li>
                        <li>
                            <a className={`nav-link account_link ${selectedTab === '/mantras' ? 'active' : ''}`} onClick={() => navigationHandler('/mantras')}>
                                <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M2.50396 0.972092C2.14458 1.09709 1.84771 1.40178 1.75005 1.75725C1.73052 1.83147 1.71099 2.30022 1.71099 2.79631V3.69866L1.32427 3.71819C0.988331 3.73381 0.910206 3.75334 0.730519 3.85491C0.0313 4.24162 0.0430188 5.24162 0.746144 5.601C0.941456 5.70256 1.0313 5.72209 1.3438 5.73381L1.71099 5.74944V6.48381V7.21428L1.32427 7.23381C0.988331 7.24944 0.910206 7.26897 0.730519 7.37053C0.0313 7.75725 0.0430188 8.75725 0.746144 9.11662C0.941456 9.21819 1.0313 9.23772 1.3438 9.24944L1.71099 9.26506V9.99944V10.7299L1.32427 10.7494C0.988331 10.7651 0.910206 10.7846 0.730519 10.8862C0.0313 11.2729 0.0430188 12.2729 0.746144 12.6322C0.941456 12.7338 1.0313 12.7533 1.3438 12.7651L1.71099 12.7807V13.5151V14.2455L1.32427 14.2651C0.988331 14.2807 0.910206 14.3002 0.730519 14.4018C0.0313 14.7885 0.0430188 15.7885 0.746144 16.1479C0.941456 16.2494 1.0313 16.269 1.33989 16.2807L1.70708 16.2963L1.7188 17.2807C1.73052 18.2104 1.73442 18.269 1.82036 18.4252C1.95708 18.683 2.12896 18.8549 2.36724 18.9721L2.58989 19.0815L8.08599 19.0932C14.1641 19.1049 13.879 19.1127 14.4258 18.8549C15.004 18.5776 15.4688 18.0463 15.6836 17.4096L15.793 17.0893V9.99944V2.90959L15.6836 2.58928C15.5547 2.20256 15.2579 1.74553 14.9805 1.50334C14.7149 1.26897 14.3243 1.06975 13.9532 0.975998C13.6602 0.901779 13.5 0.897873 8.17974 0.897873C3.02739 0.901779 2.69536 0.905685 2.50396 0.972092ZM13.75 1.56584C14.0899 1.64006 14.3672 1.79631 14.6329 2.05412C14.9219 2.34319 15.0899 2.67131 15.1485 3.06584C15.1993 3.44084 15.1993 16.558 15.1485 16.933C15.043 17.6635 14.4649 18.2846 13.75 18.433C13.6055 18.4643 11.9532 18.476 8.16411 18.476C3.12114 18.476 2.77739 18.4721 2.64849 18.4057C2.57427 18.3705 2.47271 18.2807 2.42583 18.2065C2.33989 18.0776 2.33599 18.0424 2.33599 17.1869V16.3002L2.69927 16.2807C3.10552 16.2572 3.26958 16.2026 3.48833 16.0112C3.92583 15.6244 3.92583 14.9213 3.48833 14.5346C3.26958 14.3432 3.10552 14.2885 2.69927 14.2651L2.33599 14.2455V13.5151V12.7846L2.69927 12.7651C3.10552 12.7416 3.26958 12.6869 3.48833 12.4955C3.92583 12.1088 3.92583 11.4057 3.48833 11.019C3.26958 10.8276 3.10552 10.7729 2.69927 10.7494L2.33599 10.7299V9.99944V9.26897L2.69927 9.24944C3.10552 9.226 3.26958 9.17131 3.48833 8.97991C3.92583 8.59319 3.92583 7.89006 3.48833 7.50334C3.26958 7.31194 3.10552 7.25725 2.69927 7.23381L2.33599 7.21428V6.48381V5.75334L2.69927 5.73381C3.10552 5.71037 3.26958 5.65569 3.48833 5.46428C3.92583 5.07756 3.92583 4.37444 3.48833 3.98772C3.26958 3.79631 3.10552 3.74162 2.69927 3.71819L2.33599 3.69866V2.81194C2.33599 1.95647 2.33989 1.92131 2.42583 1.7924C2.47271 1.71819 2.57427 1.62834 2.64849 1.59319C2.77739 1.52678 3.12114 1.52287 8.16411 1.52287C12.0274 1.52287 13.6016 1.53459 13.75 1.56584ZM2.96099 4.37834C3.08599 4.42522 3.19536 4.58537 3.19536 4.726C3.19536 4.86662 3.08599 5.02678 2.96099 5.07366C2.76958 5.14006 1.22661 5.12834 1.06255 5.05803C0.871144 4.97991 0.789113 4.78069 0.867238 4.58928C0.964894 4.36272 1.06646 4.33928 2.01177 4.33928C2.50396 4.33928 2.89068 4.35491 2.96099 4.37834ZM2.96099 7.89397C3.08599 7.94084 3.19536 8.101 3.19536 8.24162C3.19536 8.38225 3.08599 8.54241 2.96099 8.58928C2.76958 8.65569 1.22661 8.64397 1.06255 8.57366C0.871144 8.49553 0.789113 8.29631 0.867238 8.10491C0.964894 7.87834 1.06646 7.85491 2.01177 7.85491C2.50396 7.85491 2.89068 7.87053 2.96099 7.89397ZM2.96099 11.4096C3.08599 11.4565 3.19536 11.6166 3.19536 11.7572C3.19536 11.8979 3.08599 12.058 2.96099 12.1049C2.76958 12.1713 1.22661 12.1596 1.06255 12.0893C0.871144 12.0112 0.789113 11.8119 0.867238 11.6205C0.964894 11.394 1.06646 11.3705 2.01177 11.3705C2.50396 11.3705 2.89068 11.3862 2.96099 11.4096ZM2.96099 14.9252C3.08599 14.9721 3.19536 15.1322 3.19536 15.2729C3.19536 15.4135 3.08599 15.5737 2.96099 15.6205C2.76958 15.6869 1.22661 15.6752 1.06255 15.6049C0.871144 15.5268 0.789113 15.3276 0.867238 15.1362C0.964894 14.9096 1.06646 14.8862 2.01177 14.8862C2.50396 14.8862 2.89068 14.9018 2.96099 14.9252Z" fill="#fff" />
                                    <path d="M5.12891 4.51172L5.03125 4.60547V6.48438V8.36328L5.12891 8.45703L5.22266 8.55469H9.46484H13.7109L13.8242 8.44141L13.9375 8.32812V6.48438V4.64062L13.8242 4.52734L13.7109 4.41406H9.46484H5.22266L5.12891 4.51172ZM13.3125 6.48438V7.92969H9.48438H5.65625V6.48438V5.03906H9.48438H13.3125V6.48438Z" fill="#fff" />
                                    <path d="M5.12891 11.543C5.06641 11.6016 5.03125 11.6836 5.03125 11.7578C5.03125 11.832 5.06641 11.9141 5.12891 11.9727L5.22266 12.0703H9.46484H13.7109L13.8242 11.957C13.8867 11.8945 13.9375 11.8047 13.9375 11.7578C13.9375 11.7109 13.8867 11.6211 13.8242 11.5586L13.7109 11.4453H9.46484H5.22266L5.12891 11.543Z" fill="#fff" />
                                    <path d="M5.12891 15.0586C5.06641 15.1172 5.03125 15.1992 5.03125 15.2734C5.03125 15.3477 5.06641 15.4297 5.12891 15.4883L5.22266 15.5859H9.46484H13.7109L13.8242 15.4727C13.8867 15.4102 13.9375 15.3203 13.9375 15.2734C13.9375 15.2266 13.8867 15.1367 13.8242 15.0742L13.7109 14.9609H9.46484H5.22266L5.12891 15.0586Z" fill="#fff" />
                                </svg>
                                <span>Mantras</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </aside>
            {/* <ErrorBoundry> */}
                <Outlet />
            {/* </ErrorBoundry> */}

            <Modal
                show={qbResume}
                onHide={qbHide}
                backdrop="static"
                className="detail_modal report_modal qbQuit_modal"
                centered
            >
                <Modal.Body>
                    <div className="rating_modal_body text-center">
                        <h5>Are you sure you want to quit this Test?</h5>
                        <p>You can anytime come back and continue from where you left.</p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="rating_submit">
                        <button type="button" className="btn btn_theme" onClick={qbHide}>Cancel</button>
                        <button type="button" className="btn btn_theme btn_theme_red" onClick={() => gotoInstrucation()}>Yes, Quit</button>
                    </div>
                </Modal.Footer>
            </Modal>

            <Modal
                show={Resume}
                onHide={Hide}
                backdrop="static"
                className="detail_modal report_modal qbQuit_modal"
                centered
            >
                <Modal.Body>
                    <div className="rating_modal_body text-center">
                        <h5>Are you sure you want to quit this QB?</h5>
                        <p>You can anytime come back and continue from where you left.</p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="rating_submit">
                        <button type="button" className="btn btn_theme" onClick={Hide}>Cancel</button>
                        <button type="button" className="btn btn_theme btn_theme_red" onClick={() => qbgotoInstrucation()}>Yes, Quit</button>
                    </div>
                </Modal.Footer>
            </Modal>

            {/* update profile modal */}
            {/* <Modal show={updateModal}
                // onHide={logoutHide}
                backdrop="static"
                className="detail_modal report_modal device_reached"
                centered>
                <Modal.Body>
                    <div className="account_option_wrapper">
                        <div className="account_header text-center">
                            <h6>Please update your college to access the app</h6>
                                                <p>You won’t be able to edit the college later so please make sure that you set the correct college. For any queries contact support@egurukulapp.com</p>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <div className="rating_submit">
                    <a href="/#/account/editProfile" className="usr_image">
                        <button type="submit" className="btn btn_theme" onClick={redirectToProfile}>
                            Update profile
                        </button>
                    </a>
                </div>
            </Modal.Footer>
        </Modal > */}
            <Modal
                show={Resume}
                onHide={Hide}
                backdrop="static"
                className="detail_modal report_modal qbQuit_modal"
                centered
            >
                <Modal.Body>
                    <div className="rating_modal_body text-center">
                        <h5>Are you sure you want to quit this QB?</h5>
                        <p>You can anytime come back and continue from where you left.</p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="rating_submit">
                        <button type="button" className="btn btn_theme" onClick={Hide}>Cancel</button>
                        <button type="button" className="btn btn_theme btn_theme_red" onClick={() => qbgotoInstrucation()}>Yes, Quit</button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>


    )
}

export default Sidebar